import moment from "moment";
import {
  TextFieldType,
  AutocompleteType,
  CheckboxType,
} from "../../utilis/component/CustomFormElement";
const today = moment(new Date()).format("yyyy-MM-DD");
type SearchFieldsType = {
  fromDate: TextFieldType;
  toDate: TextFieldType;
  insuranceType: AutocompleteType;
  insuranceTpaName: AutocompleteType;
  insuranceName: AutocompleteType;
  insurancePlan: AutocompleteType;
  Postoffice: AutocompleteType;
  claimStatus: AutocompleteType;
  transcationStatus: AutocompleteType;
  verificationStatus: AutocompleteType;
  all: CheckboxType;
  specialCase: CheckboxType;
};

export const insTypes = ["TPA", "Insurance", "Corporate"];
export const insNames = [
  "Insurance name A",
  "Insurance name B",
  "Insurance name C",
];
export const insGroups = [
  "Insurance group A",
  "Insurance group B",
  "Insurance group C",
];
export const insPlans = [
  "Insurance plan A",
  "Insurance plan B",
  "Insurance plan C",
];
export const postoffices = ["Riayati", "DHPO", "Shafafiya"];
export const searchFields: SearchFieldsType = {
  fromDate: {
    element: "datepicker",
    name: "fromDate",
    fieldProps: { label: "From Date", inputProps: { max: today } },
    rules: { required: "From date required" },
  },
  toDate: {
    element: "datepicker",
    name: "toDate",
    fieldProps: { label: "To Date" },
    rules: { required: "To date required" },
  },
  insuranceType: {
    element: "autocomplete",
    name: "insuranceType",
    fieldProps: { label: "Insurance Type" },
    rules: { required: "Insurance Type required" },
    autocompleteProps: {
      isOptionEqualToValue: (option, value) => option.id == value.id,
      getOptionLabel: (option) => option.name,
    },
  },
  insuranceTpaName: {
    element: "autocomplete",
    name: "tpaName",
    fieldProps: { label: "Receiver" },
    rules: { required: "Receiver required" },
    autocompleteProps: {
      isOptionEqualToValue: (option, value) => option.id == value.id,
      getOptionLabel: (option) => option.name,
    },
  },
  insuranceName: {
    element: "autocomplete",
    name: "insuranceName",
    fieldProps: { label: "Payer" },
    rules: { required: "Payer required" },
    autocompleteProps: {
      isOptionEqualToValue: (option, value) => option.id == value.id,
      getOptionLabel: (option) => option.name,
    },
  },
  
  insurancePlan: {
    element: "autocomplete",
    name: "insurancePlan",
    fieldProps: { label: "Insurance Plan" },
    rules: { required: "Insurance Plan required" },
    autocompleteProps: {
      isOptionEqualToValue: (option, value) => option.id == value.id,
      getOptionLabel: (option) => option.name,
    },
  },

  Postoffice: {
    element: "autocomplete",
    name: "postoffice",
    fieldProps: { label: "Post Office" },
    rules: { required: "Post Office required" },
    autocompleteProps: {
      isOptionEqualToValue: (option, value) => option.po_id == value.po_id,
      getOptionLabel: (option) => option.po_name,
    },
  },
  claimStatus: {
    element: "autocomplete",
    name: "claimStatus",
    fieldProps: { label: "Claim Status" },
    rules: { required: false },
  },
  transcationStatus: {
    element: "autocomplete",
    name: "transcationStatus",
    fieldProps: { label: "Transcation Status" },
    rules: { required: false },
  },
  verificationStatus: {
    element: "autocomplete",
    name: "verificationStatus",
    fieldProps: { label: "Verification Status" },
    rules: { required: false },
  },
  all: {
    name: "all",
    element: "checkbox",
    fieldProps: { label: "All" },
    rules: { required: false },
  },
  specialCase: {
    name: "specialCase",
    element: "checkbox",
    fieldProps: { label: "Special Case" },
    rules: { required: false },
  },
};
